var _linearGradient, _linearGradient2, _pattern, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEccProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 48,
    width: 48,
    id: "svg927",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs931"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1579"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1575",
    offset: 0,
    style: {
      stopColor: "#d35dad",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop1577",
    offset: 1,
    style: {
      stopColor: "#d35dad",
      stopOpacity: 0
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 110.623,
    x2: 136.985,
    y1: 110.623,
    x1: 79.962,
    id: "linearGradient1585",
    xlinkHref: "#linearGradient1579"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.46113 0 0 .66973 -48.236 -182.195)",
    xlinkHref: "#linearGradient1579",
    id: "linearGradient1585-7",
    x1: 79.962,
    y1: 110.623,
    x2: 136.985,
    y2: 110.623,
    gradientUnits: "userSpaceOnUse"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "EMFhbasepattern",
    patternUnits: "userSpaceOnUse",
    width: 6,
    height: 6,
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g925",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    textAnchor: "none",
    fontSize: "none",
    fontWeight: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none"
    },
    id: "path903",
    d: "M0 172V0h172v172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.807 24.266h56.025a9 9 45 0 1 9 9v82.128a9 9 135 0 1-9 9H44.807a9 9 45 0 1-9-9V33.266a9 9 135 0 1 9-9z",
    id: "rect1501",
    style: {
      fill: "none",
      stroke: "#d35dad",
      strokeWidth: 6.68853,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.227 51.788h56.026a9 9 45 0 1 9 9v82.128a9 9 135 0 1-9 9H71.227a9 9 45 0 1-9-9V60.788a9 9 135 0 1 9-9z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "#d35dad",
      strokeWidth: 6.68854,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect1501-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.962 68.599h39.023a9 9 45 0 1 9 9v66.05a9 9 135 0 1-9 9H88.962a9 9 45 0 1-9-9v-66.05a9 9 135 0 1 9-9z",
    id: "rect1501-4-7",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "url(#linearGradient1585)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.37841,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90)",
    d: "M77.599-136.253h65.317a9 9 45 0 1 9 9v38.29a9 9 135 0 1-9 9H77.599a9 9 45 0 1-9-9v-38.29a9 9 135 0 1 9-9z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "url(#linearGradient1585-7)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.32044,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect1501-4-7-0"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2707"
  }, ".st0{fill:#59baea}.st1{fill:#586e7c}.st2{fill:#bbcad5}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEccProfile);
export default __webpack_public_path__ + "static/media/eccProfile.6456883eb31dcfb91ea93b8a94c79b4f.svg";
export { ForwardRef as ReactComponent };